// extracted by mini-css-extract-plugin
export var userActivityHeader = "user-activity__header_L__OD6hH1MDaTbWFSqx1";
export var userActivityOnlineLabel = "user-activity__online-label_e9DAOCj5Ag6_uOc52KTy";
export var userActivityOnlineNotify = "user-activity__online-notify_O0KVeDwFAaJEhssNKCTs";